import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      ...CommonFonts.grayFont16,
    },
    value: {
      ...CommonFonts.grayFont18,
    },
    input: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    box: {
      marginBottom: theme.spacing(10),
      cursor: 'pointer',
      [theme.breakpoints.up('sm')]: {
        marginRight: theme.spacing(25),
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(7),
      },
    },
    boxWithDescription: {
      marginBottom: theme.spacing(10),
      cursor: 'pointer',
    },
    titleText: {
      ...CommonFonts.darkFont18,
    },
    descriptionText: {
      ...CommonFonts.grayFont14,
    },
    boxPromotion: {
      marginTop: theme.spacing(7),
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
    },
    boxPromotionItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    boxNotFound: {
      padding: theme.spacing(10),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    switchHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    boxSwitchPOS: {
      paddingBottom: theme.spacing(10),
    },
    optionsSwitchPOS: {
      ...CommonFonts.darkFont14,
      fontWeight: 600,
      paddingRight: theme.spacing(3),
    },
    boxOptions: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(12),
    },
    input: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    addAction: {
      textTransform: 'capitalize',
      cursor: 'pointer',
      color: '#1174F2',
      fontSize: 14,
    },
    boxDialog: {
      '& .MuiDialog-paperWidthFalse': {
        maxWidth: '840px',
      },
    },
  })
);

export default useStyles;
